var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel margin--bottom granary-right-panel" },
    [
      _c("bar-card", { attrs: { bg: "border-new" } }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "chart-box" }, [
            _c("div", { ref: "chart", staticClass: "chart" }),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }